import React from 'react';
import Navigation from '@/components/Navigation';
import { PageHeading } from '@/components/ui/page-heading';
import OrderingPageCustomizer from '@/components/admin/ordering-page/OrderingPageCustomizer';

/**
 * OrderingPage - Main page component for the Code Injection Creator
 * 
 * This page provides a UI for restaurant staff to generate customised 
 * CSS and JavaScript code injections for their CloudWaitress ordering pages.
 */
const OrderingPage: React.FC = () => {
  return (
    <Navigation>
      <div className="space-y-6">
        <PageHeading 
          title="Ordering Page Customisation" 
          description="Customise the appearance of your Pump'd ordering page with pre-built components"
        />
        <OrderingPageCustomizer />
      </div>
    </Navigation>
  );
};

export default OrderingPage;